<template>
    <div class="st borderb-gray pt20 mb15">
        <router-link class="more fr trans3 fs14 tc6 mt5" :to="more">更多&gt;&gt;</router-link>
        <span class="fs24 lh10 prelative st-nm before dinline-block">{{ stitle }}</span>
    </div>
</template>
<script>
export default {
    props: ['stitle', 'type', 'id', 'more']
}
</script>
<style scope>
    .fs16 .more{
        font-size: 16px;
    }
    .line.st {
        border-width: 1px;
    }

    .line.st .st-nm {
        padding-bottom: 15px;
        padding-left: 15px;
        font-size: 20px;
        color: var(--mcolor);
    }

    .line.st .st-nm::before {
        left: 0;
        right: auto;
        top: 2px;
        bottom: auto;
        width: 4px;
        height: 18px;
        background: var(--mcolor);
    }
</style>